const dayNamesByNumber = new Map([
  [0, "Sunday"],
  [1, "Monday"],
  [2, "Tuesday"],
  [3, "Wednesday"],
  [4, "Thursday"],
  [5, "Friday"],
  [6, "Saturday"],
  [7, "Sunday"],
]);

const dayNamesByKey = new Map([
  ["SUNDAY", "Sunday"],
  ["MONDAY", "Monday"],
  ["TUESDAY", "Tuesday"],
  ["WEDNESDAY", "Wednesday"],
  ["THURSDAY", "Thursday"],
  ["FRIDAY", "Friday"],
  ["SATURDAY", "Saturday"],
]);

export function formatCaregiverAvailabilityDay(day: number | string) {
  if (typeof day === "number") {
    return dayNamesByNumber.get(day) ?? `Day ${day}`;
  }

  return dayNamesByKey.get(day.toUpperCase()) ?? day;
}

export function formatCaregiverAvailabilityTime(hourMinutes: number) {
  const hours = Math.floor(hourMinutes / 60);
  const minutes = hourMinutes % 60;
  const normalizedHours = hours === 24 ? 0 : hours;
  const suffix = normalizedHours >= 12 ? "PM" : "AM";
  const displayHours = normalizedHours % 12 === 0 ? 12 : normalizedHours % 12;

  return `${displayHours}:${String(minutes).padStart(2, "0")} ${suffix}`;
}

export function formatCaregiverAvailabilityRange(startHour: number, endHour: number) {
  return `${formatCaregiverAvailabilityTime(startHour)} - ${formatCaregiverAvailabilityTime(
    endHour
  ).replace("12:00 AM", "24:00")}`;
}

export function getAvailabilityProgressPercent(value: number | null, maxValue: number) {
  if (value === null) {
    return 0;
  }

  return Math.max(0, Math.min(100, (value / maxValue) * 100));
}
